import { ObjectLike } from '@/types/objectlike.types';
import { iComment } from './review.types';

export class Comment implements iComment {
  id: string;

  userId: string;

  createdAt: number;

  gamertag: string;

  text: string;

  constructor(
    id: string,
    userId: string,
    gamertag: string,
    text: string,
    createdAt: number,
  ) {
    this.id = id;
    this.userId = userId;
    this.text = text;
    this.createdAt = createdAt;
    this.gamertag = gamertag;
  }

  toObject(): ObjectLike {
    return {
      id: this.id,
      userId: this.userId,
      gamertag: this.gamertag,
      text: this.text,
      createdAt: this.createdAt,
    };
  }
}
